<template>
    <body class="signIn">
        <div class="text1">申请报名吉林一号遥感开发者培训班</div>
        <div class="white" v-if="signInSuccess==1">
        <div class="text2">您已成功提交报名申请，请等待审核</div>
            <div class="homeBack" @click="$router.push('/');refreshLocation();">返回首页</div>
          </div>
        <div class="white" v-if="signInSuccess==2">
            <div class="text3">恭喜！</div>
            <div class="text4">您已通过审核并成功加入吉林一号遥感开发者培训班。欢迎您开启线上学习之旅。</div>
                <div class="homeBack" @click="$router.push('/globalCourse');refreshLocation();">去学习</div>
        </div>
        <div class="white" v-if="signInSuccess==4">
            <div class="text3">恭喜！</div>
            <div class="text4">您已通过审核并成功加入吉林一号遥感开发者培训班·长春站”。请您留意短信和邮件通知，关注我们的最新消息！</div>
                <div class="homeBack" @click="$router.push('/');refreshLocation();">返回首页</div>
        </div>
        <div class="white" v-if="signInSuccess==3">
            <div class="text3">很抱歉！</div>
            <div class="text4">您未通过报名审核。请确认您所填的信息真实有效，如有问题请联系我们的教育专员。</div>
            <div class="text4" style="top: 184px;">0431-86008580 (工作日工作时)</div>
                <div class="homeBack" @click="signInRepeat()">重新报名</div>
        </div>
        <div class="white" v-if="signInSuccess==5">
            <div class="text3">很抱歉！</div>
            <div class="text4">吉林一号遥感开发者培训班·长春站 报名已额满，如有其他问题请联系我们的教育专员。</div>
            <div class="text4" style="top: 184px;">0431-86008580 (工作日工作时)</div>
                <div class="homeBack" @click="$router.push('/');refreshLocation();">返回首页</div>
        </div>
        <div class="white" v-if="signInSuccess==6">
            <div class="text3">很抱歉！</div>
            <div class="text4">您未通过报名审核。请确认您所填的信息真实有效，如有问题请联系我们的教育专员。</div>
            <div class="text4" style="top: 184px;">0431-86008580 (工作日工作时)</div>
        </div>
    </body>
</template>
<script>
    export default {
      name: "signInResult",
      data() {
        return {
            signInSuccess:1,
            isOnLine:0,
        };
      },
      methods: {
        getKey() {
          return localStorage.getItem("token");
        },
        refreshLocation() {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
          });
        },
        signInRepeat(){
          this.$router.push({path:'/signInContent',query:{'type':1}})
          this.$store.state.agentRepeat=1
          this.refreshLocation();
        }
      },
    
      mounted() {
        this.isOnLine=this.$route.query.type;
        //判断当前状态
      this.axios
      .get("/learn_back/course/register/queryCourseRegisterStatus", { 
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
      })
      .then((res) => {
        if(this.isOnLine==1){
          let onlineStatus=res.data.data.onlineStatus
          if(onlineStatus==1){
            this.signInSuccess=1
          }else if(onlineStatus==2){
            this.signInSuccess=2
          }
          // else if(onlineStatus==3){
          //   this.signInSuccess=3
          // }
        }else if(this.isOnLine==2){
          let offLineStatus=res.data.data.offlineStatus
          if(offLineStatus==1){//审核中
            this.signInSuccess=1
          }else if(offLineStatus==2){//成功
            this.signInSuccess=4
          }else if(offLineStatus==3){//失败
            this.signInSuccess=3
          }else if(offLineStatus==0){
            this.signInSuccess=5
          }
        }
      });
      },
      created(){
      }
    };
</script>
<style scoped>
    .signIn {
  position: relative;
  width: 100%;
  height: 100%;
  background: #f5f5f6;
}
.text1 {
  position: absolute;
  top: 174px;
  left: calc(50% - 208px);
  width: 416px;
  height: 31px;
  font-size: 26px;
  font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
  font-weight: normal;
  color: #3a3a3a;
  line-height: 31px;
  text-align: center;
}
.white {
  position: absolute;
  top: 259px;
  left: calc(50% - 640px);
  width: 1280px;
height: 400px;
  background: #ffffff;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
}
.text2{
    position: absolute;
    top: 119px;
    left: calc(50% - 160px);
    width: 320px;
height: 28px;
font-size: 20px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 28px;
text-align: center;

}
.homeBack{
    position: absolute;
    top: 259px;
    left: calc(50% - 75px);
    width: 150px;
height: 44px;
background: #C49760;
border-radius: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 44px;
text-align: center;
cursor: pointer;
}
.text3{
    position: absolute;
    top: 67px;
    left: calc(50% - 100px);
    width: 200px;
height: 37px;
font-size: 26px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 37px;
text-align: center;
}
.text4{
    position: absolute;
    top: 136px;
    left: calc(50% - 400px);
    width: 800px;
height: 64px;
font-size: 18px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 32px;
text-align: center;
}
</style>